import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const CONSENT_KEY = "cookie_consent_v1";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const stored = localStorage.getItem(CONSENT_KEY);
      if (!stored) setVisible(true);
    } catch (e) {
      /* localStorage unavailable — do nothing */
    }
  }, []);

  const accept = () => {
    if (typeof window !== "undefined" && typeof window.__grantMarketingConsent === "function") {
      window.__grantMarketingConsent();
    }
    setVisible(false);
  };

  const decline = () => {
    if (typeof window !== "undefined" && typeof window.__denyMarketingConsent === "function") {
      window.__denyMarketingConsent();
    }
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          data-testid="cookie-banner"
          initial={{ y: 120, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 120, opacity: 0 }}
          transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-0 inset-x-0 z-[70] px-4 pb-4 sm:px-6 sm:pb-6"
          style={{ paddingBottom: "calc(env(safe-area-inset-bottom, 0) + 1rem)" }}
        >
          <div className="max-w-3xl mx-auto bg-ink text-cream rounded-lg shadow-2xl border border-white/10 p-5 sm:p-6">
            <div className="flex flex-col sm:flex-row sm:items-start gap-4">
              <div className="flex-1 text-[13px] sm:text-sm leading-relaxed" style={{ color: "#F5F0E8" }}>
                <p className="mb-1 font-semibold">Cookies e privacidade</p>
                <p style={{ color: "#F5F0E8CC" }}>
                  Usamos cookies para melhorar o site e medir campanhas (Google Ads e Meta)
                  — apenas com o teu consentimento. Se recusares, tudo funciona na mesma.
                  Podes alterar a escolha a qualquer momento.
                </p>
              </div>
              <div className="flex flex-col sm:flex-row gap-2 sm:items-center shrink-0">
                <button
                  onClick={decline}
                  data-testid="cookie-decline"
                  className="px-5 py-2.5 text-sm font-medium rounded-full transition-colors border"
                  style={{
                    borderColor: "#F5F0E855",
                    color: "#F5F0E8",
                    background: "transparent",
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.background = "#F5F0E81A")}
                  onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
                >
                  Recusar
                </button>
                <button
                  onClick={accept}
                  data-testid="cookie-accept"
                  className="px-5 py-2.5 text-sm font-semibold rounded-full transition-colors"
                  style={{
                    background: "#E25A2C",
                    color: "#F5F0E8",
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.background = "#C94A22")}
                  onMouseLeave={(e) => (e.currentTarget.style.background = "#E25A2C")}
                >
                  Aceitar todos
                </button>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
